(function (root) {
  var lifetime = 7 * 24 * 60 * 60 * 1000;
  function imageURL(value, base) {
    if (!value || typeof value !== 'string' || value.length > 2048) throw new Error('Missing preview image');
    var url = new URL(value, base);
    if (url.protocol !== 'https:' || url.username || url.password) throw new Error('Preview needs a secure saved image link');
    return url.href;
  }
  function valid(p) {
    if (!p || typeof p.reference !== 'string' || !/^[a-zA-Z0-9_-]{1,120}$/.test(p.reference) || typeof p.email !== 'string' || p.email.length > 254 || typeof p.style !== 'string' || p.style.length > 120) throw new Error('Invalid preview');
    p.image = imageURL(p.image);
    return p;
  }
  function createLink(product, preview, origin, api, storage) {
    var url = new URL(product, origin);
    if (url.origin !== origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) throw new Error('Invalid product link');
    var p = valid({image:imageURL(preview.image, api),email:String(preview.email || '').slice(0,254),style:String(preview.style || '').slice(0,120),reference:String(preview.reference || ''),productPath:url.pathname,expires:Date.now()+lifetime});
    var store = storage || root.localStorage;
    for (var i = store.length - 1; i >= 0; i--) {
      var key = store.key(i);
      if (key && key.startsWith('ep-preview:')) {
        try { var old = JSON.parse(store.getItem(key)); if (!old.expires || old.expires < Date.now()) store.removeItem(key); } catch (_) { store.removeItem(key); }
      }
    }
    store.setItem('ep-preview:'+p.reference, JSON.stringify(p));
    url.searchParams.set('view','preview-checkout');
    url.hash = new URLSearchParams({ep_ref:p.reference}).toString();
    return url.href;
  }
  function readLink(link, storage) {
    try {
      var url = new URL(link), hash = new URLSearchParams(url.hash.slice(1)), ref = hash.get('ep_ref');
      if (ref) {
        if (!/^[a-zA-Z0-9_-]{1,120}$/.test(ref)) return null;
        var store = storage || root.localStorage, p = JSON.parse(store.getItem('ep-preview:'+ref));
        if (!p || p.productPath !== url.pathname || p.reference !== ref) return null;
        if (!Number.isFinite(p.expires) || p.expires < Date.now()) { store.removeItem('ep-preview:'+ref); return null; }
        return valid(p);
      }
      var raw = hash.get('ep_preview');
      if (!raw || raw.length > 4096) return null;
      return valid(JSON.parse(raw));
    } catch (_) { return null; }
  }
  function properties(p) {
    return {'Preview reference':p.reference,'Preview image':p.image,'Preview style':p.style,'_Preview email':p.email};
  }
  var api = {createLink:createLink,readLink:readLink,properties:properties};
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.EPPreviewHandoff = api;
})(typeof window !== 'undefined' ? window : globalThis);
